export const messageActions = {
  threadShow: 'thread.show',
};
